import React, { Component } from 'react'
import {Route, Switch} from 'react-router-dom';


export default function Footer() {
    let copyRight = '2020-' + new Date().getFullYear() + ' Farmers Food Assistance Bureau – All Rights Reserved.';

    let DefaultFooter = () => {
        return (
        <footer className="container">
            <hr/>
            <a href="https://support.novodiagroup.com/hc/en-us">FAQ</a> &nbsp;
            <a href="https://www.mobileebt.com/legal/tos_app_totilpay.html">Legal</a> &nbsp;
            <a href="https://totilpay.com/about-us">About Us</a>
            <p>&copy; {copyRight}</p>
        </footer>
        )
    };

    let BlankFooter = () => {
        return null;
    };

    return (
      <Switch>
        <Route path="/program/pans/view" component={BlankFooter} />
        <Route path="/" component={DefaultFooter} />
      </Switch>
    );
}
  